/* 
// jQuery: initMVWSearchFilterControls
// MVW Search Filter Controls is used to handle navigation of the My Vacation Watcher Search process
*/

jQuery(function initMVWSearchFilterControls($) {
	$('.mvw-filter-controls').each(function(index, el) {

		// Main variables
		var $container                  = $(this);
		var $secondaryFilterControls    = $container.find('.secondary-filter-controls');
		var $filterSets                 = $container.find('.js-filter-container');
		var $buttonControls             = $container.find('.js-button-control');
		var $closeButtons               = $container.find('.close-btn');

		// Additional Variables
		var isTransitioning             = false;
		var animationParameters         = {duration: 500, queue: false};

		// Travel Date Created Range Controls
		var $dateCreatedFrom = $('#date-range-beginning').pickadate({
			min: 14,
			max: 358,
			format: 'mm-dd-yyyy'
		});
		var dateCreatedFromPicker = $dateCreatedFrom.pickadate('picker');

		var $dateCreatedTo = $('#date-range-ending').pickadate({
			min: 20,
			max: 365,
			format: 'mm-dd-yyyy'
		});
		var dateCreatedToPicker = $dateCreatedTo.pickadate('picker');

		// Check if there is an initial Start or End date
		if ( dateCreatedFromPicker.get('value') ) {
			dateCreatedToPicker.set('min', dateCreatedFromPicker.get('select'));
		}
		
		if ( dateCreatedToPicker.get('value') ) {
			dateCreatedFromPicker.set('max', dateCreatedToPicker.get('select'));
		}

		// **************************************************************************************************************
		// FUNCTION:    initializeControls
		// PARAMETERS:  none
		// DESCRIPTION: This function handles setting up the event handlers for all of the Search Process Interface Controls
		// **************************************************************************************************************
		var initializeControls = function() {
			// **************************************************************************************************************
			// Primary and Secondary Filter Button Controls
			// **************************************************************************************************************
			$('.btn-destination').click(function(event) { toggleFilter($('.btn-destination'), $('.destination-filters')); });
			$('.btn-travel-dates').click(function(event) { toggleFilter($('.btn-travel-dates'), $('.travel-date-filters')); });
			$('.btn-price-types').click(function(event) { toggleFilter($('.btn-price-types'), $('.price-type-filters')); });
			$('.btn-price-range').click(function(event) { if (!$secondaryFilterControls.hasClass('disabled')) { toggleFilter($('.btn-price-range'), $('.price-range-filters')); } });
			$('.btn-unit-type').click(function(event) { if (!$secondaryFilterControls.hasClass('disabled')) { toggleFilter($('.btn-unit-type'), $('.unit-type-filters')); } });
			$('.btn-options').click(function(event) { if (!$secondaryFilterControls.hasClass('disabled')) { toggleFilter($('.btn-options'), $('.options-filters')); } });

			// **************************************************************************************************************
			// Filter Section Close Button Controls
			// **************************************************************************************************************
			$closeButtons.each(function(el) {
				$(this).click(function(event) {
					// Turn on the isTransitioning boolean to prevent other events from triggering
					isTransitioning = true;
					toggleButton($($(this).closest('.filter-set').data('button')), 'off');
					closeFilterSet($(this).closest('.js-filter-container'));
				});
			});

			// **************************************************************************************************************
			// Save Search Button Control
			// **************************************************************************************************************
			$('.js-save-search').click(function() {
				if (!isTransitioning) {
					// Turn on the isTransitioning boolean to prevent other events from triggering
					isTransitioning = true;
					saveSearch();
				}
			});

			// **************************************************************************************************************
			// Reset Travel Date Range Filter Control
			// **************************************************************************************************************
			$('.js-clear-dates').click(function() {
				if (!isTransitioning) {
					dateCreatedFromPicker.clear();
					dateCreatedToPicker.clear();
					$('.js-date-start').trigger('change');
				}
			});

			// **************************************************************************************************************
			// Reset Secondary Filters Control
			// **************************************************************************************************************
			$('.reset-secondary-filters').click(function() {
				if (!isTransitioning) {
					// Turn on the isTransitioning boolean to prevent other events from triggering
					isTransitioning = true;
					clearSecondaryFilters();
				}
			});

			// **************************************************************************************************************
			// Destination [Region] Controls
			// **************************************************************************************************************
			$('.region').each(function(el) {
				$(this).click(function(event) {
					$(this).toggleClass('open');
					$(this).next('.js-toggle-block').toggle();
				});
			});

			// **************************************************************************************************************
			// Destination [Sub-Region] Controls
			// **************************************************************************************************************
			$('.sub-region').each(function(el) {
				$(this).click(function(event) {
					$(this).toggleClass('open');
					$(this).next('.js-toggle-block').toggle();
				});
			});

			// **************************************************************************************************************
			// Primary Filter [Destinations] Checkbox Controls
			// **************************************************************************************************************
			$('.destination-filters').find('.js-destination-checkbox .js-filter-checkbox').each(function(el) {
				$(this).click(function(event) {
					var subRegionItems   = false;
					var regionItems      = false;
					var destinationItems = false;

					// Determine if we have any filter selections
					subRegionItems   = checkFilterSelections($(this).closest('.sub-region-block'));
					regionItems      = checkFilterSelections($(this).closest('.region-block'));
					destinationItems = checkFilterSelections($('.destination-filters'));

					if (subRegionItems) {
						$(this).closest('.sub-region-block').find('.name').addClass('selected');
					} else {
						$(this).closest('.sub-region-block').find('.name').removeClass('selected');
					}

					if (regionItems) {
						$(this).closest('.region-block').find('.region .name').addClass('selected');
					} else {
						$(this).closest('.region-block').find('.region .name').removeClass('selected');
					}

					if (destinationItems) {
						$('.btn-destination').addClass('selected');
					} else {
						$('.btn-destination').removeClass('selected');
					}
				});
			});
	
			// **************************************************************************************************************
			// Primary Filter [Travel Dates] Date Range Controls
			// **************************************************************************************************************
			$container.find('.input-date').each(function(el) {
				$(this).change(function(event) {
					var startDate      = $('.js-date-start').val();
					var endDate        = $('.js-date-end').val();

					if (startDate !== '' && endDate !== '') {
						$('.btn-travel-dates').addClass('selected');
					} else {
						$('.btn-travel-dates').removeClass('selected');
					}
				});
			});

			// When something is selected for the "Beginning" Travel Date, update the "dateCreatedFrom" and "dateCreatedTo" limits.
			dateCreatedFromPicker.on('set', function(event) {
				if ( event.select ) {
					dateCreatedToPicker.set('min', dateCreatedFromPicker.get('select'));

					dateCreatedToPicker.set('max', 365);
					var newMaxDate = new Date(dateCreatedToPicker.get('min','mm-dd-yyyy'));
					newMaxDate.setTime(newMaxDate.getTime() + 90*86400000);
					var oldMaxDate = new Date(dateCreatedToPicker.get('max','mm-dd-yyyy'));

					if (newMaxDate < oldMaxDate) {
						dateCreatedToPicker.set('max', newMaxDate);
					}
				} else if ( 'clear' in event ) {
					dateCreatedToPicker.set('min', 20);
					dateCreatedToPicker.set('max', 365);
				}
			});

			// When something is selected for the "Ending" Travel Date, update the "dateCreatedFrom" and "dateCreatedTo" limits.
			dateCreatedToPicker.on('set', function(event) {
				if ( event.select ) {
					dateCreatedFromPicker.set('max', dateCreatedToPicker.get('select'));

					dateCreatedFromPicker.set('min', 14);
					var newMinDate = new Date(dateCreatedFromPicker.get('max','mm-dd-yyyy'));
					newMinDate.setTime(newMinDate.getTime() - 90*86400000);
					var oldMinDate = new Date(dateCreatedFromPicker.get('min','mm-dd-yyyy'));

					if (newMinDate > oldMinDate) {
						dateCreatedFromPicker.set('min', newMinDate);
					}
				} else if ( 'clear' in event ) {
					dateCreatedFromPicker.set('max', 358);
					dateCreatedFromPicker.set('min', 14);
				}
			});

			// **************************************************************************************************************
			// Price Types Checkbox Controls
			// **************************************************************************************************************
			$container.find('.primary-filter-container .js-checkbox .js-filter-checkbox').each(function(el) {
				$(this).click(function(event) {
					var filterItems = false;
					var button = $(this).closest('.filter-set').data('button');

					// Determine if we have any filter selections
					filterItems = checkFilterSelections($(this).closest('.filter-set'));

					if (filterItems) {
						$(button).addClass('selected');
					} else {
						$(button).removeClass('selected');
					}
				});
			});

			// **************************************************************************************************************
			// Secondary Filter Checkbox Controls
			// **************************************************************************************************************
			$container.find('.secondary-filter-container .js-checkbox .js-filter-checkbox').each(function(el) {
				$(this).click(function(event) {
					if ($(this).hasClass('js-occupancy')) {
						// This is an occupancy filter, we need to uncheck its siblings (it is treated like a radio button)
						$(this).closest('.js-checkbox').siblings().find('.js-filter-checkbox').prop('checked',false);
					}

					var filterItems = false;
					var button = $(this).closest('.filter-set').data('button');

					// Determine if we have any filter selections
					filterItems = checkFilterSelections($(this).closest('.filter-set'));

					if (filterItems) {
						$(button).addClass('selected');

						// Enable the Secondary Filters Reset Button
						toggleResetButton('on');
					} else {
						$(button).removeClass('selected');

						// Disable the Secondary Filters Reset Button
						toggleResetButton('off');
					}
				});
			});
		};

		// **************************************************************************************************************
		// FUNCTION:    saveSearch
		// PARAMETERS:  none
		// DESCRIPTION: This function handles building out the proper variables to be passed to the application to save a search
		// **************************************************************************************************************
		var saveSearch = function() {
			$('.js-error-message').empty().hide();
			$('.js-success-message').empty().hide();
			toggleLoading('on');

			// Perform Search Stuff
			var selections          = [];
			selections.destinations = $('.js-destination:checked').toArray();
			selections.pricetype    = $('.js-pricetype:checked').toArray();
			selections.allinclusive = $('.js-allinclusive:checked').toArray();
			selections.price        = $('.js-price:checked').toArray();
			selections.bedroom      = $('.js-bedroom:checked').toArray();
			selections.occupancy    = $('.js-occupancy:checked').toArray();
			selections.kitchen      = $('.js-kitchen:checked').toArray();

			var destinationURL  = buildFilterSegmentURL(selections.destinations, 'destinations');
			var priceTypeURL    = buildFilterSegmentURL(selections.pricetype, 'price-types');
			var allInclusiveURL = buildFilterSegmentURL(selections.allinclusive, 'all-inclusive');
			var priceRangeURL   = buildFilterSegmentURL(selections.price, 'price-ranges');
			var bedroomTypeURL  = buildFilterSegmentURL(selections.bedroom, 'bedroom-types');
			var occupancyURL    = buildFilterSegmentURL(selections.occupancy, 'occupancy');
			var kitchenTypeURL  = buildFilterSegmentURL(selections.kitchen, 'kitchen-types');

			// Obtain Travel Dates
			var travelDatesURL = '';
			if ($('.js-date-start').val() !== '' && $('.js-date-end').val() !== '') {
				travelDatesURL = '/travel-dates/' + $('.js-date-start').val() + '-through-' + $('.js-date-end').val();
			}

			// Build out the complete URL string
			var facetedURL = destinationURL + travelDatesURL + priceTypeURL + allInclusiveURL + priceRangeURL + bedroomTypeURL + occupancyURL + kitchenTypeURL;
			var searchName = $('#search-name').val();
			var searchID   = $('#search-id').val();

			if (facetedURL !== '' && searchName !== '') {
				// The user has submitted the MVW Search form with at least one selection
				var completeURL = '/search-resorts/results' + facetedURL;

				// Run the AJAX function to save the MVW Search
				$.ajax({
					method: "POST",
					url: "/h/mvw/SaveSearch",
					data: { completeURL: completeURL, searchName: searchName, searchID: searchID }
				})
				.done(function( data ) {
					var dataJSON = JSON.parse(data);

					if (dataJSON !== '') {
						$('#search-id').val(dataJSON.searchID);
						var newSearchID = dataJSON.searchID;

						if (dataJSON.type === 'error') {
							$('.js-error-message').html(dataJSON.errorMessage);
							$('.js-error-message').show();
							toggleLoading('off');
						} else {
							$('.js-success-message').html('Your My Vacation Watcher Search was saved successfully!');
							$('.js-success-message').show();
							toggleLoading('off');

							// Add tracking pixels
							if (dataJSON.trackingPixel !== '') {
								$container.append(dataJSON.trackingPixel);
							}

							if (dataJSON.type === 'save-and-search') {
								// Search saved, and results exist
								var transferURL = '/search-resorts/transfer/' + newSearchID + '/results' + facetedURL;
								$('.modal-message-availability .view-availability-link').attr('href', transferURL);
								var modalHTML = $('.modal-message-availability').html();
								launchMessageDialog(modalHTML);
							}
						}
					}
				});
			} else {
				if (facetedURL === '') {
					$('.js-error-message').html('Please select at least one criteria to save your search.');
				} else {
					$('.js-error-message').html('Please enter a vacation name to save your search.');
				}
				$('.js-error-message').show();
				toggleLoading('off');
			}
		};

		// **************************************************************************************************************
		// FUNCTION:    buildFilterSegmentURL
		// PARAMETERS:  selectionSet (the set of checkbox options, in array format, that are "checked" for this specific segmentType)
		//              segmentType (the type, or category, of checkbox options that are being processed)
		// DESCRIPTION: This function builds out a url structure segment identical to what our search process router on the application looks for to determine
		//              whether or not a url is valid and contains properly formatted url keys for the segmentType selections in question
		// **************************************************************************************************************
		var buildFilterSegmentURL = function(selectionSet, segmentType) {
			var url = '';

			if (selectionSet.length > 0) {
				url = '/' + segmentType + '/XXXX';
				selectionSet.sort(function(a,b) {
					var A = a.value.toLowerCase();
					var B = b.value.toLowerCase();

					if (A < B) {
						return -1;
					} else if (A > B) {
						return 1;
					} else {
						return 0;
					}
				});

				selectionSet.each(function(el) {
					url = url + '-and-' + el.value;
				});
				url = url.replace('XXXX-and-','');
			}

			return url;
		};

		// **************************************************************************************************************
		// FUNCTION:    toggleLoading
		// PARAMETERS:  count (the total number of resorts available in the current set of search results)
		// DESCRIPTION: This function handles toggling on and off for the "Loading" animations, and for enabling / disabling all controls during the "Loading" process 
		// **************************************************************************************************************
		var toggleLoading = function(mode) {
			if (mode === 'on') {
				// Disable all Primary Controls
				$('.filters').addClass('loading');
				$('.search-details').addClass('loading');
				$('.loader').show();
			} else {
				// Enable all Primary Controls
				$('.filters').removeClass('loading');
				$('.search-details').removeClass('loading');
				$('.loader').hide();

				// Complete the transition by resetting the transition check parameters
				isTransitioning = false;
			}
		};

		// **************************************************************************************************************
		// FUNCTION:    toggleFilter
		// PARAMETERS:  button (the button element being toggled)
		//              filter (the filter set associated with the toggled button)
		// DESCRIPTION: This function handles the toggling open and closed of a filter set when its control button is pressed
		// **************************************************************************************************************
		var toggleFilter = function(button, filter) {
			if (!isTransitioning) {
				isTransitioning = true;

				if (filter.is(':visible')) {
					toggleButton(button, 'off');
					closeFilterSet(filter);
				} else {
					toggleButton(button, 'on');
					closeAllFilterSets(filter);
				}
			}
		};

		// **************************************************************************************************************
		// FUNCTION:    toggleButton
		// PARAMETERS:  button (the button element being toggled)
		//              toggleSwitch (the state of the button we are changing to, "on" or "off")
		// DESCRIPTION: This function handles the toggling on and off of a control button when it is pressed
		// **************************************************************************************************************
		var toggleButton = function(button, toggleSwitch) {
			if (toggleSwitch === 'off') {
				$buttonControls.each(function(el) {
					$(this).removeClass('current');
				});
			} else {
				$buttonControls.each(function(el) {
					$(this).removeClass('current');
				});

				button.addClass('current');
			}
		};

		// **************************************************************************************************************
		// FUNCTION:    openFilterSet
		// PARAMETERS:  filter (the filter set associated with the toggled button, in this function, this is the filter that is going to be opened)
		// DESCRIPTION: This function handles opening of the appropriate supplied filter
		// **************************************************************************************************************
		var openFilterSet = function(filter) {
			filter.show();
			var animationHeight = filter.find('.js-filter-set-container').outerHeight();
			
			filter.animate({height: animationHeight + 'px'}, {duration: 500, queue: false,
				complete: function() {
					filter.css('height','auto');
					isTransitioning = false;
				}
			});
		};

		// **************************************************************************************************************
		// FUNCTION:    closeFilterSet
		// PARAMETERS:  filter (the filter set associated with the toggled button, in this function, this is the filter that is going to be closed)
		// DESCRIPTION: This function handles closing of the appropriate supplied filter
		// **************************************************************************************************************
		var closeFilterSet = function(filter) {
			filter.animate({height: '0px'}, {duration: 500, queue: false,
				complete: function() {
					$(this).hide();
					isTransitioning = false;
				}
			});
		};

		// **************************************************************************************************************
		// FUNCTION:    closeAllFilterSets
		// PARAMETERS:  filter (the filter set associated with the toggled button, in this function, this is the filter that is going to be opened)
		// DESCRIPTION: This function handles closing all potentially open filter sets, then opening the new appropriate filter
		// **************************************************************************************************************
		var closeAllFilterSets = function(filter) {
			var count = 0;

			$filterSets.each(function(el) {
				if ($(this).is(':visible')) { count++; }
			});

			if (count > 0) {
				$filterSets.each(function(el) {
					if ($(this).is(':visible')) {
						$(this).animate({height: '0px'}, {duration: 500, queue: false,
							complete: function() {
								$(this).hide();
								count--;
								if (count === 0) { openFilterSet(filter); }
							}
						});
					}
				});
			} else {
				openFilterSet(filter);
			}
		};

		// **************************************************************************************************************
		// FUNCTION:    resetFilterControls
		// PARAMETERS:  resetSource (the source parent element that all child checkboxes need to be reset to "enabled" instead of "disabled")
		//              resetCheckedStatus (if this status is set to "true", that means we want to "uncheck" all child checkboxes of our "resetSource" as well)
		// DESCRIPTION: This function handles resetting all child checkbox elements of the "resetSource" element to "enabled", and potentially "unchecked" as well
		// **************************************************************************************************************
		var resetFilterControls = function(resetSource) {
			// Re-enable all checkboxes
			resetSource.find('.js-filter-checkbox').each(function() {
				$(this).prop('disabled', false);
				$(this).next('span').removeClass('checkbox-label-disabled');
				$(this).prop('checked', false);
			});
		};

		// **************************************************************************************************************
		// FUNCTION:    checkFilterSelections
		// PARAMETERS:  filterSource (the parent filter set of options that contains the child checkbox elements that need to be validated)
		// DESCRIPTION: This function handles validating whether or not a checkbox in the "filterSource" is "checked". One checkbox being "checked" is sufficent for the whole set
		// **************************************************************************************************************
		var checkFilterSelections = function(filterSource) {
			var returnCheck = false;
			filterSource.find('.js-filter-checkbox').each(function() {
				if ($(this).prop('checked')) {
					// Set the 'returnCheck' to true to indicate we have at least one  selection within the filterSource subset
					// Then return false, which will break out of the each loop without further logic checks (they aren't needed, 1 selection is sufficient) 
					returnCheck = true;
					return false;
				}
			});

			return returnCheck;
		};

		// **************************************************************************************************************
		// FUNCTION:    toggleResetButton
		// PARAMETERS:  switchType (the switch to determine if we are displaying the Reset button, or hiding it)
		// DESCRIPTION: This function handles the display and hiding of the secondary filters reset button
		// **************************************************************************************************************
		var toggleResetButton = function(switchType) {
			if (switchType === 'on') {
				$('.reset-secondary-filters').show();
			} else {
				$('.reset-secondary-filters').hide();
			}
		};

		// **************************************************************************************************************
		// FUNCTION:    clearSecondaryFilters
		// PARAMETERS:  none
		// DESCRIPTION: This function handles the clearing of all secondary filter checkboxes, and re-running the new faceted search without those options
		// **************************************************************************************************************
		var clearSecondaryFilters = function() {
			// Reset all secondary filter checkboxes
			$('.secondary-filter-option-container').each(function() {
				resetFilterControls($(this));
			});

			// Reset the secondary filter control button states
			$('.btn-secondary-filter').each(function() {
				$(this).removeClass('selected');
			});

			// Disable the Secondary Filters Reset Button
			toggleResetButton('off');
			isTransitioning = false;
		};

		// **************************************************************************************************************
		// FUNCTION:    checkSecondaryFilters
		// PARAMETERS:  none
		// DESCRIPTION: This function handles determining if we have any secondary filters currently selected
		// **************************************************************************************************************
		var checkSecondaryFilters = function() {
			var secondaryFilterCheck = false;
			$container.find('.secondary-filter-container .js-checkbox .js-filter-checkbox').each(function(el) {
				if ($(this).prop("checked")) {
					// Set "secondaryFilterCheck" to true, because we found at least one checked item, so we know we have existing Secondary Filter Options
					// Then return false, which will break out of the each loop without further logic checks (they aren't needed, 1 match is sufficient) 
					secondaryFilterCheck = true;
					return false;
				}
			});

			return secondaryFilterCheck;
		};

		// **************************************************************************************************************
		// FUNCTION:    checkDestinationFilters
		// PARAMETERS:  none
		// DESCRIPTION: This function handles determining if we have any destinations filters currently selected, which we use to determine if Map View should be enabled
		// **************************************************************************************************************
		var checkDestinationFilters = function() {
			var destinationFilterCheck = false;
			$('.destination-filters').find('.js-destination-checkbox .js-filter-checkbox').each(function(el) {
				if ($(this).prop("checked")) {
					// Set "destinationFilterCheck" to true, because we found at least one checked item, so we know we have existing Secondary Filter Options
					// Then return false, which will break out of the each loop without further logic checks (they aren't needed, 1 match is sufficient) 
					destinationFilterCheck = true;
					return false;
				}
			});

			return destinationFilterCheck;
		};

		initializeControls();
	});
});